import { getformData, getPlatform } from '@/static/js/zjs'
import request from '../static/js/request'

const appid = getPlatform().appid
export function getTemporaryPayNum(openid) {
  return request({
    url: '/cms/weixin/user/findTemporaryPayNumByOpenid',
    method: 'GET',
    params: { openid }
  }).then((res) => res.data)
}

export function getYouzanVipGift(data) {
  return request({
    url: '/cms/weixin/user/getYouzanVipGift',
    method: 'POST',
    data: getformData(data)
  }).then((res) => res.data)
}

// 按一定规则，获取用户一张优惠卡券
export function getUserCardByRule(data) {
  return request({
    url: '/cms/weixin/user/weixincard/getUserCard',
    method: 'POST',
    data: getformData(data)
  }).then((res) => res.data)
}
// 获取优惠卡券的价格
export function getCardSubPrice(data) {
  return request({
    url: '/cms/weixin/user/weixincard/getCardSubPrice',
    method: 'POST',
    data: getformData(data)
  }).then((res) => res.data)
}

export function getMakeCardSign(data) {
  return request({
    url: '/cms/weixin/user/weixincard/makeCardSign',
    method: 'POST',
    data: getformData(data)
  }).then((res) => res.data)
}
// 创建订单接口
export function createOrder(data) {
  return request({
    url: '/cms/weixin/user/order/create',
    method: 'POST',
    data: getformData(data)
  }).then((res) => res.data)
}
export function postPublishOrder() {
  return request({
    url: '/cms/weixin/user/publish-order',
    method: 'POST'
  }).then((res) => res.data)
}
// 获取用户优惠券列表
export function getUserBusifavorList({ openid, pkg }) {
  return request({
    url: `/mopa/api-pay/open/coupon/user/stock/coupon-list/${appid}/${openid}`,
    method: 'POST',
    data: getformData({
      appid,
      openid,
      pkg
    })
  }).then((res) => res.data)
}
// 获取优惠支付信息
export function getDiscountInfo(data) {
  return request({
    url: '/cms/weixin/coupon/get-discount-info',
    method: 'POST',
    data: getformData(data)
  }).then((res) => res.data)
}
// 获取优惠券发放链接
export function getBusifavorLink(data) {
  const { stockId, openid } = data
  return request({
    url: `/mopa/api-pay/open/coupon/user/stock/send/${stockId}/${openid}`,
    method: 'POST',
    data: getformData(data)
  }).then((res) => res.data)
}
// 获取优惠券状态
export function getBusifavorStatus(data) {
  const { stockId, openid } = data
  return request({
    url: `/mopa/api-pay/open/coupon/user/stock/status/${stockId}/${openid}`,
    method: 'GET'
  }).then((res) => res.data)
}
// 支付失败
export function vipPayFail(payOrderId) {
  return request({
    method: 'GET',
    url: `/cms/weixin/operation_group/vipPayFail/${payOrderId}`
  })
}
